import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import faTimesCircle from "@fortawesome/fontawesome-free-solid/faTimesCircle";
import faHome from "@fortawesome/fontawesome-free-solid/faHome";
import { Localized } from "fluent-react/compat";
import { NavLink } from "react-router-dom";
import ClassNames from "classnames";
import PropTypes from "prop-types";
import { subUserTools } from "@capps/subuser-tools";

import logoLaddition from "../../img/logo_laddition.png";
import config from "../../config";
import { hasSearchedGroup } from "../../utils/utils";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: props.accessToken,
      mobile: false,
      width: window.innerWidth,
      hash: window.location.hash,
      hasEspaceClientGroup: false,
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.displayBurgerMenu = this.displayBurgerMenu.bind(this);
    this.handlerIsMobile = this.handlerIsMobile.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    this.checkEspaceClientGroup();
  }

  componentDidUpdate() {
    if (
      this.state.width < 769 &&
      this.state.mobile &&
      this.state.hash !== window.location.hash
    ) {
      this.setState(
        {
          mobile: !this.state.mobile,
          hash: window.location.hash,
        },
        () => this.props.isMobile(!this.state.mobile)
      );
    }

    if (this.state.accessToken !== this.props.accessToken) {
      this.setState({ accessToken: this.props.accessToken }, () => {
        this.checkEspaceClientGroup();
      });
    }
  }

  UNSAFE_componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  handlerIsMobile(e) {
    e.preventDefault();
    this.setState(
      {
        mobile: !this.state.mobile,
      },
      () => this.props.isMobile(this.state.mobile)
    );
  }

  displayBurgerMenu() {
    return (
      <a
        data-cypress="burger-menu"
        type="button"
        href="#menu"
        id="menuLink"
        className={ClassNames({
          hamburger: true,
          "hamburger--spring": true,
          "is-active": this.state.mobile,
        })}
        onClick={this.handlerIsMobile}
      >
        <span className="hamburger-box">
          <span className="hamburger-inner" />
        </span>
      </a>
    );
  }

  async redirectToEC(e) {
    e.preventDefault();

    try {

      const urlAuth = config.urlAuth;
      const urlEspaceClient = config.urlEspaceClient;

      const isSubUser = !!this.state.accessToken && subUserTools.isSubUserAccount(this.state.accessToken);

      return isSubUser ? window.location.href = urlAuth : window.location.href = urlEspaceClient;
    } catch (error) {
      console.error("Error when trying to redirect:", error);
    }
  }

  async checkEspaceClientGroup() {
    const hasEspaceClientGroup = await hasSearchedGroup(this.state.accessToken, 'espace_client');
    this.setState({ hasEspaceClientGroup });
  }

  render() {
    //const burgerMenu = this.displayBurgerMenu();
    const { hasEspaceClientGroup } = this.state;

    return (
      <header>
        {/* this.state.width < 769 ? burgerMenu : "" */}
        <div className="content">
          <div className="circle-orange" />
          <div id="title">
            <h1 className="logo">
              <img src={logoLaddition} alt="logo laddition" /> /{" "}
              <Localized id="tr-admin-command" />
            </h1>
            <div className="buttons-menu">
              <div id="logout">
                <button onClick={(e) => logout(e)}>
                  <FontAwesomeIcon
                    size="2x"
                    className="admin-fa-icon"
                    icon={faTimesCircle}
                  />
                  <Localized id="tr-deconnect" />
                </button>
              </div>

              {hasEspaceClientGroup && (
                <div id="back-to-ec">
                  <button onClick={(e) => this.redirectToEC(e)}>
                    <FontAwesomeIcon
                      size="2x"
                      className="admin-fa-icon"
                      icon={faHome}
                    />
                    <Localized id="tr-back-to-ec" />
                  </button>
                </div>
              )}
            </div>
          </div>
          <h1 className="title">{<Localized id="tr-admin-manage-module" />}</h1>

          <div id="menu">
            <ul>
              <li>
                <NavLink
                  activeClassName={"active"}
                  to={"/general"}
                  className={` ${!window.chrome ? "topLine" : ""}`}
                >
                  <p>
                    <Localized id="tr-link-general" />
                  </p>
                  <hr />
                </NavLink>
              </li>
              <li>
                <NavLink
                  activeClassName={"active"}
                  to={"/adresse"}
                  className={` ${!window.chrome ? "topLine" : ""}`}
                >
                  <p>
                    <Localized id="tr-link-address" />
                  </p>
                  <hr />
                </NavLink>
              </li>
              <li>
                <NavLink
                  activeClassName={"active"}
                  to={"/horaires"}
                  className={` ${!window.chrome ? "topLine" : ""}`}
                >
                  <p>
                    <Localized id="tr-link-hours" />
                  </p>
                  <hr />
                </NavLink>
              </li>
              <li>
                <NavLink
                  activeClassName={"active"}
                  to={"/carte"}
                  className={` ${!window.chrome ? "topLine" : ""}`}
                >
                  <p>
                    <Localized id="tr-link-cart" />
                  </p>
                  <hr />
                </NavLink>
              </li>
              <li>
                <NavLink
                  activeClassName={"active"}
                  to={"/logistique"}
                  className={` ${!window.chrome ? "topLine" : ""}`}
                >
                  <p>
                    <Localized id="tr-link-logistics" />
                  </p>
                  <hr />
                </NavLink>
              </li>
              {this.props.stripeAvailable ? (
                <li>
                  <NavLink
                    activeClassName={"active"}
                    to={"/stripe"}
                    className={`${!window.chrome ? "topLine" : ""}`}
                  >
                    <p>
                      <Localized id="tr-link-stripe" />
                    </p>
                    <hr />
                  </NavLink>
                </li>
              ) : null}
              <li>
                <NavLink
                  activeClassName={"active"}
                  to={"/presentation"}
                  className={`${!window.chrome ? "topLine" : ""}`}
                >
                  <p>
                    <Localized id="tr-link-presentation" />
                  </p>
                  <hr />
                </NavLink>
              </li>
              <li>
                <NavLink
                  activeClassName={"active"}
                  to={"/publication"}
                  className={`${!window.chrome ? "topLine" : ""}`}
                >
                  <p>
                    <Localized id="tr-link-publication" />
                  </p>
                  <hr />
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="bg-white" />
      </header>
    );
  }
}

Menu.propTypes = {
  isMobile: PropTypes.func.isRequired,
  accessToken: PropTypes.string,
};

export default Menu;

const logout = (e) => {
  e.preventDefault();
  let urlLogout = config.logAuth;
  try {
    window.localStorage.clear();
    window.location.replace(urlLogout);
  } catch (e) {
    return e;
  }
};
